'use strict';

var styled = require('styled-components');
var styles = require('../Heading/styles.js');
var styles$1 = require('../Text/styles.js');
var styles$2 = require('../Button/styles.js');
var styles$3 = require('../Icon/styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const getCardColorCss = (tokens) => styled.css `
  background: ${tokens.getBackgroundColor};

  ${styles.Styled.Div},
  ${styles$1.Styled.Span} {
    color: ${tokens.getTextColor};
  }
  ${styles$2.Styled.Button} {
    color: ${tokens.getButtonTextColor};
    background: ${tokens.getButtonBackgroundColor};
    border: 1px solid transparent;
    &:hover,
    &.hover {
      background: ${tokens.getButtonHoveredBackgroundColor};
      border: 1px solid transparent;
    }
    &:focus,
    &.focus {
      background: ${tokens.getButtonFocusedBackgroundColor};
      border: 1px solid transparent;
    }
  }
  ${styles$3.Styled.Container} {
    color: ${tokens.getIconTextColor};
  }
`;
const stylesByColor = {
    blue: getCardColorCss({
        getBackgroundColor: ({ theme }) => theme.designTokens.coloredCardBlueBackgroundColor,
        getTextColor: ({ theme }) => theme.designTokens.coloredCardBlueTextColor,
        getButtonTextColor: ({ theme }) => theme.designTokens.coloredCardBlueButtonTextColor,
        getButtonBackgroundColor: ({ theme }) => theme.designTokens.coloredCardBlueButtonBackgroundColor,
        getButtonHoveredBackgroundColor: ({ theme }) => theme.designTokens.coloredCardBlueButtonHoverBackgroundColor,
        getButtonFocusedBackgroundColor: ({ theme }) => theme.designTokens.coloredCardBlueButtonFocusBackgroundColor,
        getIconTextColor: ({ theme }) => theme.designTokens.coloredCardBlueIconTextColor,
    }),
    red: getCardColorCss({
        getBackgroundColor: ({ theme }) => theme.designTokens.coloredCardRedBackgroundColor,
        getTextColor: ({ theme }) => theme.designTokens.coloredCardRedTextColor,
        getButtonTextColor: ({ theme }) => theme.designTokens.coloredCardRedButtonTextColor,
        getButtonBackgroundColor: ({ theme }) => theme.designTokens.coloredCardRedButtonBackgroundColor,
        getButtonHoveredBackgroundColor: ({ theme }) => theme.designTokens.coloredCardRedButtonHoverBackgroundColor,
        getButtonFocusedBackgroundColor: ({ theme }) => theme.designTokens.coloredCardRedButtonFocusBackgroundColor,
        getIconTextColor: ({ theme }) => theme.designTokens.coloredCardRedIconTextColor,
    }),
    green: getCardColorCss({
        getBackgroundColor: ({ theme }) => theme.designTokens.coloredCardGreenBackgroundColor,
        getTextColor: ({ theme }) => theme.designTokens.coloredCardGreenTextColor,
        getButtonTextColor: ({ theme }) => theme.designTokens.coloredCardGreenButtonTextColor,
        getButtonBackgroundColor: ({ theme }) => theme.designTokens.coloredCardGreenButtonBackgroundColor,
        getButtonHoveredBackgroundColor: ({ theme }) => theme.designTokens.coloredCardGreenButtonHoverBackgroundColor,
        getButtonFocusedBackgroundColor: ({ theme }) => theme.designTokens.coloredCardGreenButtonFocusBackgroundColor,
        getIconTextColor: ({ theme }) => theme.designTokens.coloredCardGreenIconTextColor,
    }),
    orange: getCardColorCss({
        getBackgroundColor: ({ theme }) => theme.designTokens.coloredCardOrangeBackgroundColor,
        getTextColor: ({ theme }) => theme.designTokens.coloredCardOrangeTextColor,
        getButtonTextColor: ({ theme }) => theme.designTokens.coloredCardOrangeButtonTextColor,
        getButtonBackgroundColor: ({ theme }) => theme.designTokens.coloredCardOrangeButtonBackgroundColor,
        getButtonHoveredBackgroundColor: ({ theme }) => theme.designTokens.coloredCardOrangeButtonHoverBackgroundColor,
        getButtonFocusedBackgroundColor: ({ theme }) => theme.designTokens.coloredCardOrangeButtonFocusBackgroundColor,
        getIconTextColor: ({ theme }) => theme.designTokens.coloredCardOrangeIconTextColor,
    }),
    purple: getCardColorCss({
        getBackgroundColor: ({ theme }) => theme.designTokens.coloredCardPurpleBackgroundColor,
        getTextColor: ({ theme }) => theme.designTokens.coloredCardPurpleTextColor,
        getButtonTextColor: ({ theme }) => theme.designTokens.coloredCardPurpleButtonTextColor,
        getButtonBackgroundColor: ({ theme }) => theme.designTokens.coloredCardPurpleButtonBackgroundColor,
        getButtonHoveredBackgroundColor: ({ theme }) => theme.designTokens.coloredCardPurpleButtonHoverBackgroundColor,
        getButtonFocusedBackgroundColor: ({ theme }) => theme.designTokens.coloredCardPurpleButtonFocusBackgroundColor,
        getIconTextColor: ({ theme }) => theme.designTokens.coloredCardPurpleIconTextColor,
    }),
    yellow: getCardColorCss({
        getBackgroundColor: ({ theme }) => theme.designTokens.coloredCardYellowBackgroundColor,
        getTextColor: ({ theme }) => theme.designTokens.coloredCardYellowTextColor,
        getButtonTextColor: ({ theme }) => theme.designTokens.coloredCardYellowButtonTextColor,
        getButtonBackgroundColor: ({ theme }) => theme.designTokens.coloredCardYellowButtonBackgroundColor,
        getButtonHoveredBackgroundColor: ({ theme }) => theme.designTokens.coloredCardYellowButtonHoverBackgroundColor,
        getButtonFocusedBackgroundColor: ({ theme }) => theme.designTokens.coloredCardYellowButtonFocusBackgroundColor,
        getIconTextColor: ({ theme }) => theme.designTokens.coloredCardYellowIconTextColor,
    }),
};
const Card = styled__default.default.div `
  padding: ${({ theme }) => theme.designTokens.coloredCardPaddingY}
    ${({ theme }) => theme.designTokens.coloredCardPaddingX};
  border-radius: ${({ theme }) => theme.designTokens.coloredCardRadius};
  border: 1px solid transparent;

  ${({ color }) => stylesByColor[color]}
`;
const Styled = {
    Card,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
